import { IDataSource } from '@poweredsoft/data';
import { IDynamicComponent } from '../../../dynamic-component/IDynamicComponent';

export interface ICommandModalContext {
  dataSource: IDataSource<any>;
  title: string;
  command: string;
  commandModel: any;
  component: IDynamicComponent; 
}
